
var stringUtil = require('../../utils/string/stringUtil');
var stateManager = require('../../utils/state/stateManager.js');
var userNotificationsAction = require('../../utils/state/actions/userNotifications/userNotificationsAction.js');
const notificationChannel = require('../messaging/notification/notificationChannel');

module.exports.UserActionNotification = "user.action.notification";
module.exports.userNotifications = [];


module.exports.addUpdateNotifications = function(notificationPayload)
{
    if (notificationPayload == null)
        return;

    if (notificationPayload.isRead == null)
        notificationPayload.isRead = false;

    module.exports.userNotifications = module.exports.userNotifications.filter(u => !stringUtil.areStringSame(u.id, notificationPayload.id));
    module.exports.userNotifications.push(notificationPayload);
    stateManager.getStore().dispatch(userNotificationsAction.createAction(new Date().getTime()));

    return notificationPayload;
}

module.exports.deleteAndPublishNotification = function(notificationId)
{
    const messagePayload = {};
    messagePayload.notificationType = this.UserActionNotification;
    messagePayload.actionPayload = { id : notificationId };
    messagePayload.action = 'delete';
    notificationChannel.publishMessage(messagePayload);

    this.deleteNotifications(notificationId);
}

module.exports.deleteNotifications = function(notificationId)
{
    module.exports.userNotifications = module.exports.userNotifications.filter(u => !stringUtil.areStringSame(u.id, notificationId));
    stateManager.getStore().dispatch(userNotificationsAction.createAction(new Date().getTime()));
}

module.exports.getUnReadNotifications = function()
{
    return this.userNotifications.filter(n => !n.isRead);
}